<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Transaction</h3>
        <v-btn flat icon color="primary" title="Load Report History" @click="viewRptHistory">
          <v-icon>mdi-archive</v-icon>
          <rpt-jobs-history title="Report History" id="cargoTransaction" v-model="rptHistory" @close="doClose"></rpt-jobs-history>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field :label="labels.customName" v-model="reportForm.customName" data-vv-name="customName" :data-vv-as="labels.customName"></v-text-field>
              </v-flex>
              <v-flex xs12 md6></v-flex>
              <v-flex xs12 md6>
                <v-autocomplete :items="intermediaryList" v-model="reportForm.intermediary" :label="labels.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="labels.intermediary" :error-messages="errors.collect('intermediary')" @input="doInter"></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete :items="productList" v-model="reportForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" clearable :loading="productLoading"></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete :items="statusList" v-model="reportForm.status" :label="labels.status" item-text="label" item-value="value" data-vv-name="status" :data-vv-as="labels.status" :error-messages="errors.collect('status')" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.reportForm.fromDate"></cal-picker>
              </v-flex>
              <v-flex lg6 xs12>
                <v-checkbox v-model="reportForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
              </v-flex>
              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import RptJobsHistory from '../../shared/RptJobsHistory'

export default {
  data() {
    return {
      labels: {
        customName: 'Report Name',
        intermediary: 'Intermediary',
        product: 'Product',
        status: 'Status',
        fromDate: 'Acceptance Date From*',
        toDate: 'Acceptance Date To*',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?'
      },
      reportForm: {
        customName: undefined,
        intermediary: undefined,
        product: undefined,
        status: undefined,
        fromDate: undefined,
        toDate: undefined,
        format: undefined,
        sendEmail: false
      },
      menu: {},
      intermediaryList: [],
      productList: [],
      statusList: [],
      supportedFormat: [],
      submitting: false,
      productLoading: false,
      rptHistory: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      const result = 'required|from_to_date:' + this.reportForm.fromDate
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.cargoTransaction
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.intermediaryList = data.intermediaryList
            this.productList = data.productList
            this.statusList = data.statusList
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)

            // If there is only 1 intermediary in the list, assign it
            if (this.intermediaryList && this.intermediaryList.length === 1) {
              this.reportForm.intermediary = this.intermediaryList[0].value
              this.doInter()
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    doInter() {
      this.getProduct()
    },
    async getProduct() {
      try {
        const apiURI = this.menu.product
        if (apiURI) {
          try {
            this.productLoading = true
            const expand = {
              intermediary: this.reportForm.intermediary
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result.data
              if (data) {
                this.productList = data
              }
            }
            if (this.reportForm.product && this.productList && this.productList.length > 0) {
              // check if product is stil valid
              let productIsValid = false
              for (var i = 0; i < this.productList.length; i++) {
                const product = this.productList[i]
                if (product.value === this.reportForm.product) {
                  productIsValid = true
                  break
                }
              }
              // Invalid Product (reset to undefined)
              if (!productIsValid) {
                this.reportForm.product = undefined
              }
            } else {
              this.reportForm.product = undefined
            }
            this.productLoading = false
          } catch (error) {
            this.productLoading = false
            throw error
          }
        } else {
          this.errorMessage('Invalid API URL')
          this.productLoading = false
        }
      } catch (err) {
        this.productLoading = false
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    viewRptHistory() {
      this.rptHistory = true
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'intermediary') {
            this.reportForm.intermediary = value
            this.doInter()
          } else if (key === 'product') {
            this.reportForm.product = value
          } else if (key === 'status') {
            this.reportForm.status = value
          } else if (key === 'fromDate') {
            this.reportForm.fromDate = new Date(value)
          } else if (key === 'toDate') {
            this.reportForm.toDate = new Date(value)
          } else if (key === 'format') {
            this.reportForm.format = value
          } else if (key === 'sendEmail') {
            this.reportForm.sendEmail = value
          }
        })
      }
      this.rptHistory = false
    }
  },
  components: {
    RptJobsHistory
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
